import React, { useState } from "react";

import Odds from "./Odds";
import OddsPCHeaderItem from "./Odds.pc.HeaderItem";
import PropTypes from "prop-types";
import { useClickOutside } from "../../hooks";

function OddsPC(props) {
  const [showDropdown, setShowDropdown] = useState(false);
  const { trackingInfo } = props;

  const currentRef = useClickOutside(
    () => {
      setShowDropdown(false);
    },
    { disabled: !showDropdown }
  );

  const handleMenuItemClick = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <OddsPCHeaderItem
      reference={currentRef}
      handleClick={handleMenuItemClick}
      show={showDropdown}
      trackingInfo={trackingInfo}
    >
      <div className="odds-content">
        <Odds handleClick={handleMenuItemClick} trackingInfo={trackingInfo} />
      </div>
    </OddsPCHeaderItem>
  );
}

OddsPC.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(OddsPC);
